// src/modules/appointments/components/AppointmentPayments.jsx
import { useState } from "react";

export default function AppointmentPayments({ appointment, onAdd }) {
  const [form, setForm] = useState({
    amount: "",
    method: "",
    reference: "",
  });

  const payments = appointment?.payments || [];

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.amount || !form.method) return;
    onAdd &&
      onAdd({
        amount: Number(form.amount),
        method: form.method,
        reference: form.reference || null,
      });
    setForm({ amount: "", method: "", reference: "" });
  }

  return (
    <div className="mt-4 border rounded p-3">
      <div className="font-semibold text-xs mb-2">Pagos</div>
      {payments.length ? (
        <table className="w-full text-xs mb-3">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-1 py-1 text-left">Monto</th>
              <th className="px-1 py-1 text-left">Método</th>
              <th className="px-1 py-1 text-left">Ref</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p.id} className="border-t">
                <td className="px-1 py-1">${p.amount}</td>
                <td className="px-1 py-1">{p.method}</td>
                <td className="px-1 py-1">{p.reference || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div className="text-xs text-gray-500 mb-2">
          Sin pagos registrados.
        </div>
      )}

      <form
        onSubmit={handleSubmit}
        className="flex flex-wrap gap-2 items-end text-xs"
      >
        <div>
          <label className="block text-[10px] font-semibold">Monto *</label>
          <input
            type="number"
            min="0"
            step="0.01"
            name="amount"
            value={form.amount}
            onChange={handleChange}
            className="border rounded px-2 py-1 w-24"
          />
        </div>
        <div>
          <label className="block text-[10px] font-semibold">Método *</label>
          <input
            type="text"
            name="method"
            value={form.method}
            onChange={handleChange}
            className="border rounded px-2 py-1 w-28"
          />
        </div>
        <div>
          <label className="block text-[10px] font-semibold">Ref</label>
          <input
            type="text"
            name="reference"
            value={form.reference}
            onChange={handleChange}
            className="border rounded px-2 py-1 w-32"
          />
        </div>
        <button
          type="submit"
          className="px-3 py-1 rounded bg-green-600 text-white"
        >
          Agregar pago
        </button>
      </form>
    </div>
  );
}
